/**
 * @file log
 * @author sunhemeng
 */

/* globals swan */

/* globals getApp  getCurrentPages */
import { inSightObserverDisconnect, inSightObserverByDOM, inSightObserver } from './repeatLog.js';
import { inSightObserverDisconnectH5, inSightObserverH5 } from './repeatH5IntersectionObserverLog.js';
export function inSightObservers(target = 'defaultClass', logKey, ext, extDataKeys, isUbc = false, isNewLog = false, isNotRepeat = false, options) {
  if (!window.IntersectionObserver) {
    return 'notObserver';
  }
  // h5的曝光收集 只需要 传入 dom class/id 名 其他信息需要从节点身上获取如 page key
  return inSightObserverH5(target, isUbc, logKey, isNewLog, isNotRepeat, options);
}
export function inSightObserverDisconnects(target) {
  return inSightObserverDisconnectH5(target);
}
export function inSightObserversByDOM({
  target = 'defaultClass',
  isUbc = false,
  isNewLog = false,
  isNotRepeat = false,
  logKey = '',
  options
}) {
  if (!window.IntersectionObserver) {
    return 'notObserver';
  }
  // h5的曝光收集 只需要 传入 dom class/id 名 其他信息需要从节点身上获取如 page key
  return inSightObserverH5(target, isUbc, logKey, isNewLog, isNotRepeat, options);
}